<template>
    <b-form
        @submit.prevent="submitEmail"
    >
        <h3 style="margin-bottom: 2rem; font-size: 24px">
            <img src="@/assets/page/contacts/icon-mail.png" alt="Ícone de envio de E-mail" style="margin-right: 1rem;"
        >
            Envie sua Mensagem
        </h3>

        <b-form-input class="input" type="text" name="name" v-model="submit.name" required placeholder="Nome Completo"></b-form-input>
        <b-form-input class="input" type="text" name="enterprise" v-model="submit.enterprise" required placeholder="Empresa"></b-form-input>
        <b-form-input class="input" type="tel" name="phone" v-model="submit.phone" required placeholder="Telefone" v-mask="'(##) #####-####'"></b-form-input>
        <b-form-input class="input" type="text" name="email" v-model="submit.email" required placeholder="Email"></b-form-input>
        <b-form-textarea 
            type="text" 
            name="message" 
            v-model="submit.message" 
            required placeholder="Mensagem"
            rows="3"
            class="input"

        ></b-form-textarea>

        <b-form-checkbox
            v-model="submit.authorization"
            value="accepted"
            unchecked-value="not_accepted"
            class="checkInput"
        >
            <p style="font-size: 14px;">Autorização de comunicação e E-mail </p>
        </b-form-checkbox>

        <div class="d-flex justify-content-between alignt-items-center">
            <b-button type="submit" variant="primary" v-if="!alert.visible">
                <span v-if="loading">Enviando...</span>
                <span v-else>
                    <img src="@/assets/page/contacts/icon-submit.png" alt="" style="margin-right: 1rem;">
                    Enviar
                </span>
            </b-button>
        
            <b-alert
                :show="alert.visible"
                :variant="alert.type"
                fade
                class="wow animate__animated animate__backInLeft styleAlert "
            >
                {{ alert.message }}
            </b-alert>
        </div>

            
    </b-form>
</template>

<script>

    export default {
        data(){
            return {
                loading: false,
                submit: {},
                alert: {
                    visible: false,
                    message: '',
                    type: ''
                }
            }
        },

        methods: {
            resetInputs(){
                this.submit = {
                    name: '',
                    enterprise: '',
                    phone: '',
                    email: '',
                    message: ''
                }
            },

            isValidEmail(email) {
                const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
                return regex.test(email);
            },

            async submitEmail(){
                this.loading = true;

                const { name, phone, email, enterprise, message } = this.submit;

                    if (!name || !phone || !email || !enterprise || !message) {
                    this.alert = {
                        visible: true,
                        message: '❌ Por favor, preencha todos os campos obrigatórios!',
                        type: 'danger'
                    };
                    setTimeout(()=>{
                        this.loading = false;
                        this.alert.visible = false;
                    }, 3000)
                    return;
                }

                if (!this.isValidEmail(this.submit.email)) {
                    this.alert = {
                        visible: true,
                        message: '❌ Por favor, insira um e-mail válido.',
                        type: 'danger'
                    };
                    setTimeout(()=>{
                        this.loading = false;
                        this.alert.visible = false;
                    }, 3000)
                    return;
                }

                const formData = new FormData();
                formData.append('name', this.submit.name);
                formData.append('enterprise', this.submit.enterprise);
                formData.append('phone', this.submit.phone);
                formData.append('email', this.submit.email);
                formData.append('message', this.submit.message);
                formData.append('_subject', 'Nova mensagem do site Frazatto');
                formData.append('_captcha', 'false');
                
                try {
                    const response = await fetch("https://formsubmit.co/ajax/comercial@frazattologistica.com.br", {
                        method: 'POST',
                        body: formData,
                    })

                    if(response.ok){
                        this.alert = {
                            visible: true,
                            message: '✅ Mensagem enviada!',
                            type: 'success'
                        };
                        this.resetInputs();
                    } else {
                        this.alert = {
                            visible: true,
                            message: '❌ Erro ao enviar. Tente novamente mais tarde!',
                            type: 'danger'
                        };
                    }

                    
                } catch (error) {
                    console.error('Não foi possível enviar o email: ', error);
                    this.alert = {
                        visible: true,
                        message: '❌ Erro de rede. Verifique sua conexão.',
                        type: 'danger'
                    };
                } finally {
                    setTimeout(()=>{
                        this.loading = false;
                        this.alert.visible = false;
                    }, 3000)
                }
            }
        }
    }

</script>

<style scoped lang="scss">

    .input {
        background-color: transparent;
        border: none;
        border-bottom: 1px solid var(--primaryColor);
        margin-bottom: 2rem;
        color: var(--white);
        transition: all 0.3s ease;

        &::placeholder {
            color: var(--white);
        }

        &:hover {
            background-color: transparent;
            outline: none;
            border-bottom: 1px solid var(--white);
            color: var(--white);
        }
        &:focus {
            background-color: transparent;
            outline: none;
            border-bottom: 1px solid var(--white);
            color: var(--white);
        }

    }

    .checkInput {
        font-size: .5rem !important;
        border: none !important;
        text-align: left;
        height: 2rem;
        margin-bottom: 2rem;
        display: flex;
        justify-content: flex-start;
        align-items: center;

        p {
            margin: 0px 
        }
    }

    .styleAlert{
        margin: 0 !important;
        width: 100%;
    }

@media screen and (max-width: 500px){
    h3 {
        display: flex;
        justify-content: flex-start;
        align-items: center;
        flex-wrap: wrap;
        gap: 1rem;
        text-align: left ;

        img {
            width: 50px;
            margin: 0 !important;
        }
    }
}

</style>